module.exports = {
  colorRed60: "#B8143E",
  colorBlue80: "#0A2E5C",
  colorRed50: "#E51A4C",
  colorBlue70: "#0F448A",
  colorGray13: "#D9DCE2",
  colorRed40: "#EB4770",
  colorBlue60: "#145BB8",
  colorGray03: "#F7F7F9",
  colorRed30: "#F07593",
  colorBlue50: "#1A71E5",
  colorRed20: "#F5A1B6",
  colorBlue40: "#478EEB",
  colorGray05: "#F0F2F4",
  colorRed10: "#FAD1DB",
  colorBlue30: "#75A9F0",
  colorBlue20: "#A3C6F5",
  colorYellow80: "#664400",
  colorBlue10: "#D1E3FA",
  colorYellow70: "#996600",
  colorGray08: "#E8EAED",
  colorYellow60: "#CC8800",
  colorIndigo80: "#3E0A5C",
  colorYellow50: "#FFAA00",
  colorIndigo70: "#5D0F8A",
  colorYellow40: "#FFBB33",
  colorIndigo60: "#7D14B8",
  colorRed05: "#FCE8ED",
  colorYellow30: "#FFCC66",
  colorGreen80: "#0A5C33",
  colorIndigo50: "#9B1AE5",
  colorYellow20: "#FFDC99",
  colorGreen70: "#0F8A4C",
  colorIndigo40: "#AF47EB",
  colorYellow10: "#FFEECC",
  colorGreen60: "#14B866",
  colorIndigo30: "#C375F0",
  colorBlue05: "#E8F1FC",
  colorGreen50: "#1AE57F",
  colorIndigo20: "#D7A3F5",
  colorBlack90: "#16181D",
  colorGreen40: "#47EB99",
  colorIndigo10: "#EBD1FA",
  colorBlack80: "#2C313A",
  colorGreen30: "#76F0B3",
  colorBlack70: "#3D4451",
  colorGreen20: "#A3F5CC",
  colorBlack60: "#51596C",
  colorBlack82: "#282C34",
  colorGreen10: "#D1FAE5",
  colorBlack50: "#6E7A91",
  colorYellow05: "#FFF7E7",
  colorBlack95: "#0B0C0F",
  colorBlack: "#000000",
  colorIndigo05: "#F5E8FC",
  colorBlack87: "#1D2026",
  colorGreen05: "#E6FCF1",
  colorGray40: "#8B94A7",
  colorGray30: "#A8AFBD",
  colorGray20: "#C5CAD3",
  colorRed80: "#5C0A1F",
  colorWhite: "#FFFFFF",
  colorGray10: "#E2E4E9",
  colorRed70: "#8A0F2E",
};